/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2020-12-09 17:00:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-07 12:27:23
 * @FilePath: /unifyxp-v2-store-portal/src/router/LoginRoutes/index.ts
 */
import Layout from 'src/layout/LoginLayout/LoginLayout';
import Login from 'src/pages/Login';
import NotLogin from 'src/pages/NotLogin/NotLogin';
import { IRoutes } from 'src/types/router';
import { EPermissionSource } from 'src/types/common/resources';

const route: IRoutes = {
  layout: Layout,
  subRoutes: [
    {
      exact: true,
      path: '/login',
      component: Login,
      isPrivate: false,
      source: EPermissionSource.store,
    },
    {
      exact: true,
      path: '/notlogin',
      component: NotLogin,
      isPrivate: false,
      source: EPermissionSource.store,
    },
  ],
};
export default route;
